<template>
  <div>
    <div class="wrap coaching-finish-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>완료된 코칭</h3>
      </div>
      <div class="body-wrap" v-if="isLoading">
        <div class="time">
          <img src="@/assets/img/time-icon-b.svg" alt="시간 아이콘" />
          <p>{{ course.startDate }}({{ course.day }}) {{ course.start_time }}~{{ course.end_time }} ({{ course.time }}분)</p>
        </div>
        <div class="coach">
          <div class="info">
            <h3>{{ course.completedCoachingDetailDto.coachName }} <span>코치</span></h3>
            <h4>
              {{ course.completedCoachingDetailDto.sessionType }} 코칭 <span></span
              >{{ course.completedCoachingDetailDto.sessionPer }}회기
            </h4>
          </div>
          <div class="contact">
            <ul>
              <li @click="showMessage()"><img src="@/assets/img/talk-message.svg" alt="대화아이콘" /></li>
            </ul>
          </div>
        </div>
        <div class="coach-goal">
          <ul>
            <li>
              <h3>받고 싶은 코칭 주제</h3>
              <p class="preline">
                <font v-for="(item, index) in embededList" :key="index" :class="{ active: index == 0 }">
                  {{ index + 1 }}. {{ item.topic }}<br />
                </font>
              </p>
            </li>
            <li>
              <h3>코칭 목표</h3>
              <p class="preline">{{ course.completedCoachingDetailDto.coarchingSubject }}</p>
            </li>
            <li>
              <h3>기타의견</h3>
              <p class="preline">{{ course.completedCoachingDetailDto.coarchingEtc }}</p>
            </li>
          </ul>

          <!-- 성찰노트 -->
          <ul v-if="course.completedCoachingDetailDto.reflectIdx != null">
            <li>
              <h3>코칭 후 새롭게 알게 된 점</h3>
              <p class="preline">{{ course.completedCoachingDetailDto.reflectionContent1 }}</p>
            </li>
            <li>
              <h3>코칭 과제 및 실행 계획</h3>
              <p class="preline">{{ course.completedCoachingDetailDto.reflectionContent2 }}</p>
            </li>
            <li>
              <h3>코칭 후 기대 하는 점</h3>
              <p class="preline">{{ course.completedCoachingDetailDto.reflectionContent3 }}</p>
            </li>
          </ul>
        </div>
        <div class="modify-btn" v-if="course.completedCoachingDetailDto.reflectIdx != null">
          <span @click="modify()">수정하기</span>
        </div>
      </div>
      <div class="coaching-btn">
        <!-- 성찰노트 사용(필수,필수아님) -->
        <div
          v-if="course.completedCoachingDetailDto.reflectionNoteYn != 'N' && course.completedCoachingDetailDto.reflectIdx == null"
        >
          <button class="mb-10" @click="noteWrite()">성찰노트 작성하기</button>
        </div>

        <!-- 현재 회기가 총회기 보다 작을떄 -->
        <div>
          <button
            class="re-reserve"
            @click="reReserve()"
            v-if="Number(course.completedCoachingDetailDto.onePerson) >= Number(course.completedCoachingDetailDto.sessionPer)"
          >
            코치님과 재예약하기
          </button>
        </div>

        <!-- 성찰노트 미사용일떄 -->
        <div v-if="course.completedCoachingDetailDto.reflectionNoteYn == 'N'">
          <div v-if="course.completedCoachingDetailDto.coarchingNoteIdx != null">
            <button class="mt-10" @click="coachComment()">코치's comment 확인하기</button>
          </div>
        </div>
        <!-- 성찰노트 사용 일떄 -->
        <div v-else>
          <!-- 성찰노트 필수 일때 -->
          <div
            v-if="
              course.completedCoachingDetailDto.reflectionNoteYn == 'Y1' &&
              course.completedCoachingDetailDto.reflectIdx != null &&
              course.completedCoachingDetailDto.coarchingNoteIdx != null
            "
          >
            <button class="mt-10" @click="coachComment()">코치's comment 확인하기</button>
          </div>
          <!-- 성찰노드 필수 아닐떄 -->
          <div
            v-if="
              course.completedCoachingDetailDto.reflectionNoteYn == 'Y2' &&
              course.completedCoachingDetailDto.coarchingNoteIdx != null
            "
          >
            <button class="mt-10" @click="coachComment()">코치's comment 확인하기</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import dayjs from "dayjs";
export default {
  name: "reservation_coaching",
  props: {
    sessionIdx: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    course: {},
    weekday: ["일", "월", "화", "수", "목", "금", "토"],
    embededList: [],
    isLoading: false,
  }),
  components: { incBack },
  mounted() {
    this.getComplateCoarcingDetail();
  },
  methods: {
    showMessage() {
      this.$router.push({ name: "message", params: { coarchIdx: Number(this.course.completedCoachingDetailDto.coarchIdx) } });
    },
    getEmbededSurveyTopic() {
      let params = {
        idxTbUser: this.$store.state.userInfo.userIdx,
        courseIdx: this.course.completedCoachingDetailDto.courseIdx,
      };
      this.axios
        .get("/admin/embeddedSuerveyCoarchingTopic", { params })
        .then((res) => {
          if (res.data.success) {
            this.embededList = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    modify() {
      this.$router.push({ name: "reflection_notes_modify", params: { idx: this.sessionIdx } });
    },
    getComplateCoarcingDetail() {
      let params = {
        sessionIdx: this.sessionIdx,
      };
      this.axios
        .get("/front/coarching/complete/detail", { params })
        .then((res) => {
          if (res.data.success) {
            this.course = res.data.contentinfo;

            this.course.start_time = dayjs(this.course.completedCoachingDetailDto.startDatetime).format("HH:mm");
            this.course.end_time = dayjs(this.course.completedCoachingDetailDto.endDatetime).format("HH:mm");

            let timeValue = {
              start_time: this.course.start_time,
              end_time: this.course.end_time,
            };
            this.$store.commit("setCoachingTime", timeValue);
            this.course.time = this.$store.state.coachingTime;
            let iosDay = dayjs(this.course.startDate).format("YYYY/MM/DD");
            this.$store.commit("setCoachingDays", dayjs(iosDay).day());
            this.course.day = this.$store.state.coachingDays;

            this.course.startDate = dayjs(this.course.completedCoachingDetailDto.startDatetime).format("YYYY.MM.DD");
            console.log("/front/coarching/complete/detail API 실행 이후 getEmbededSurveyTopic() 실행");
            this.getEmbededSurveyTopic();
            this.isLoading = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    coachComment() {
      if (this.course.completedCoachingDetailDto.isSati == "1") {
        this.$router.push({ name: "coach_comment", params: { idx: this.sessionIdx } });
      } else {
        this.$router.push({ name: "satisfaction", params: { idx: this.sessionIdx } });
      }
      // alert(this.course.completedCoachingDetailDto.isSati)
      // if()
    },
    noteWrite() {
      this.$router.push({ name: "relection_notes", params: { idx: this.sessionIdx } });
    },
    reReserve() {
      this.$router.push({
        name: "reserve_subject",
        params: { rebook: 1, coachIdx: this.course.completedCoachingDetailDto.coarchIdx },
      });
    },
  },
};
</script>
